{ end:endIsObserving } = require './observations'

HISTORY_CHANGE_REQUEST = 'HISTORY_CHANGE_REQUEST'
CANCEL_CHANGE_REQUEST = 'CANCEL_CHANGE_REQUEST'
ACCEPT_CHANGE_REQUEST = 'ACCEPT_CHANGE_REQUEST'

# This is for the callback from the history library.
historyCallback = null

module.exports = {
	ACCEPT_CHANGE_REQUEST
	CANCEL_CHANGE_REQUEST
	HISTORY_CHANGE_REQUEST

	change: (_, callback) ->
		historyCallback = callback
		(dispatch, getState) ->
			state = getState()
			if state.observations.isObserving
				dispatch
					type: HISTORY_CHANGE_REQUEST
			else
				historyCallback true

	acceptChange: ->
		(dispatch) ->
			historyCallback true
			dispatch endIsObserving()
			dispatch
				type: ACCEPT_CHANGE_REQUEST

	cancelChange: ->
		historyCallback false
		{ type: CANCEL_CHANGE_REQUEST }
}



// WEBPACK FOOTER //
// ./frontend/olos/js/actions/history.coffee